// extracted by mini-css-extract-plugin
export default {"specification-input-holder":"specification-input-holder"};